// extracted by mini-css-extract-plugin
export default {"customScrollbar":"ProfilePreview_customScrollbar__v+VS2"};